module.exports = __webpack_public_path__ + "static/infrared-report-15434b63a36e5a99e9cb33c6310ab3d8.png";